<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { useTimeAgo } from '@vueuse/core';
import MyWorker from './my-worker?worker';
import ReloadPrompt from './ReloadPrompt.vue';

const pong = ref(null);
const mode = ref(null);
const worker = new MyWorker();

// replaced dynamically in vite.config.js during build
const date = '__DATE__';
const timeAgo = useTimeAgo(date);

async function runWorker() {
  worker.postMessage('ping');
}

async function resetMessage() {
  worker.postMessage('clear');
}

async function messageFromWorker({ data: { msg, mode: useMode } }) {
  pong.value = msg;
  mode.value = useMode;
}

onBeforeMount(() => {
  worker.addEventListener('message', messageFromWorker);
});

const isTestEnv = import.meta.env.VITE_APP_ENV === 'test';
</script>

<template>
  <router-view />
  <div
      v-if="isTestEnv"
      class="d-flex justify-center bg-red w-full position-absolute top-0 left-0 text-[10px]"
      style="z-index: 99999 !important;">
    Środowisko testowe
  </div>
  <!-- dev debug bar -->
  <!--    <div v-if="true" class="container mx-auto text-xs bg-slate-200 p-8">-->
  <!--        <h1 class="text-lg font-bold pb-8">DEBUG</h1>-->

  <!--        <img src="/favicon.svg" alt="PWA Logo" width="60" height="60">-->

  <!--        <br>-->
  <!--        <div>Built at: {{ date }} ({{ timeAgo }})</div>-->
  <!--        <br>-->
  <!--        <button @click="runWorker">-->
  <!--            Ping web worker-->
  <!--        </button>-->
  <!--        &#160;&#160;-->
  <!--        <button @click="resetMessage">-->
  <!--            Reset message-->
  <!--        </button>-->
  <!--        <br>-->
  <!--        <br>-->
  <!--        <template v-if="pong">-->
  <!--            Response from web worker: <span> Message: {{ pong }} </span>&#160;&#160;<span> Using ENV mode: {{ mode-->
  <!--                }}</span>-->
  <!--        </template>-->
  <!--    </div>-->
  <ReloadPrompt />
</template>
